import axios from 'axios';
import {ActionTree} from 'vuex';
import {RootState} from '@/store/types';
import {MNTemplateItem, TemplatesState, TemplatesFilterParams} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<TemplatesState, RootState> = {

  async getMailNotifyServices({commit, dispatch}, data) {
    try {
      let resp = await axios({
        url: 'lk-api/mail_notify/mn-services',
        params: data,
      });
      commit('setMNServices', resp.data);
      return resp.data;
    } catch (err) {
      throw err;
    }
  },

};